import React from "react";
import { Add } from "@mui/icons-material";
import { Fade, IconButton, styled, Tooltip } from "@mui/material";
import { useDispatch } from "react-redux";
import { addRandomAlbumToQueueAt } from "../../actions/randomModeActions";
import GrowingContainer from "../common/containers/GrowingContainer";

const RandomQueueAdderContainer = styled('div')(({theme}) => ({
    position: "relative",
    width: '100%',
    boxSizing: 'border-box',
    borderStyle: 'solid',
    borderWidth: '0.1rem',
    borderColor: theme.palette.primary.main,
    zIndex: 2
}));

const RandomQueueAdderButton = styled(IconButton)(({theme}) => ({
    position: 'absolute',
    width: '2rem',
    height: '2rem',
    top: '-1rem',
    right: 'calc(50% - 1rem)',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    transition: 'all 0.25s',
    '&:hover': {
        backgroundColor: theme.palette.primary.main,
    }
}));

const RandomQueueAdder = ({visible, queueIndex, onAdd}) => {
    const dispatch = useDispatch();

    const onClick = () => {
        if(onAdd) onAdd();
        dispatch(addRandomAlbumToQueueAt(queueIndex));
    }

    return (
        <Fade in={visible} timeout={250}>
            <RandomQueueAdderContainer onClick={onClick}>
                <GrowingContainer>
                    <Tooltip title="Add random album here">
                        <RandomQueueAdderButton><Add/></RandomQueueAdderButton>
                    </Tooltip>
                </GrowingContainer>
            </RandomQueueAdderContainer>
        </Fade>
    )
}

export default React.memo(RandomQueueAdder);